/** @jsxImportSource @emotion/react */
import { Video as VideoPlayer } from '@ssmm/ui';
import { videoList } from 'components/landing/settings';

import { Modal } from '../../ui';

const Video = ({ onClose, videoSourceId }) => (
  <Modal
    title={videoList[videoSourceId].title}
    onClose={onClose}
    getContainer={() => document.getElementById('root')}
    width={980}
  >
    <div css={{ padding: 30 }}>
      <VideoPlayer video={videoList[videoSourceId].video} autoplay />
    </div>
  </Modal>
);

export default Video;
